import React, { memo, useContext, useEffect, useState, useCallback } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';

import Button from '@mui/material/Button';

import PopupMenu from '../popupmenu';
import DataContext from '../../data/data-context';
// import { useWhatChangedEffect } from '../../libraries/withwhyrender';

const useStyles = makeStyles(theme => ({
    root: {
    },
    popperOverride: {
        backgroundColor: theme.palette.background.selectionAlt,
        '&::hover': {
            backgroundColor: theme.palette.background.selectionAlt,
        },
    },
    textButton: {
        borderRadius: 4,
        width: 163,
        fontSize: 14,
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        textAlign: 'left',
        display: 'inline-block',
    },
}));

function SensorSelector ({ value, onChange, componentclass, style }) {
    const classes = useStyles();
    const { sensorNames } = useContext(DataContext);
    const [sensors, setSensors] = useState([]);
    const [selection, setSelection] = useState('');

    useEffect(() => {
        setSensors(Object.entries(sensorNames)
            .map(([k, v]) => ({ ...v, uuid: k, name: v.name || v.host }))
            .sort((a, b) => a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1));
    }, [sensorNames]);

    useEffect(() => {
        setSelection(current => {
            const ret = current || (sensors.length ? sensors[0].uuid : undefined);
            return ret;
        });
        if (sensors.length && !value) onChange({ target: { value: sensors[0].uuid } });
    }, [value, sensors]);

    const handleOnChange = useCallback(v => {
        if (!sensorNames) return;
        if (!v) return;
        // select the first one on the list of no match
        if (sensorNames[v.uuid]) {
            setSelection(v.uuid);
            onChange({ target: { value: v.uuid } });
        } else {
            setSelection(v);
        }
    }, [sensorNames, onChange]);

    return (
        <PopupMenu
            tooltip="select sensor"
            className={classes.popperOverride}
            items={sensors}
            selection={selection}
            itemkey='uuid'
            itemTitle='name'
            onSelect={handleOnChange}
            button={
                <Button
                    style={{ textAlign: 'left', ...style }}
                    className={clsx(classes.textButton, componentclass)}
                    tooltip="select sensor"
                    aria-label="select sensor">
                    {sensorNames[value]
                        ? (sensorNames[value].name || sensorNames[value].host)
                        : value
                    }
                </Button>
            }
            size='small'
            placement={'bottom-end'}
            zIndex={1500}/>
    );
}

SensorSelector.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    componentclass: PropTypes.string,
    style: PropTypes.object
};

export default memo(SensorSelector);
